import { useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon, ImageIcon } from "../../../img/svg/adminIcons";
import AdminEmptyState from "./adminEmptyState";
import AdminSpinner from "./adminSpinner";

// visualizador de imagens do relógio: imagem ampliada (imgUrl) + miniaturas (cImgUrl)
export default function AdminWatchGallery({ images }: { images: { imgUrl: string, cImgUrl?: string }[] | undefined }) {

    const [index, setIndex] = useState(0);
    const [loading, setLoading] = useState(true);

    if (!images?.length) {
        return <AdminEmptyState icon={<ImageIcon />} title="Nenhuma imagem enviada" />;
    }

    const current = Math.min(index, images.length - 1);

    const goTo = (i: number) => {
        if (i === current || i < 0 || i >= images.length) {
            return null;
        }
        setLoading(true);
        setIndex(i);
    }

    return (
        <div className="flex flex-col gap-3">
            <div className="relative flex items-center justify-center rounded-xl bg-gray-950 h-[300px] md:h-[420px] overflow-hidden">
                {
                    loading ?
                        <span className="absolute text-white/70"><AdminSpinner size="lg" /></span>
                        : null
                }
                <img
                    key={images[current].imgUrl}
                    src={images[current].imgUrl}
                    alt={`Imagem ${current + 1}`}
                    onLoad={() => setLoading(false)}
                    onError={() => setLoading(false)}
                    className={`max-h-full max-w-full object-contain transition-opacity ${loading ? "opacity-0" : "opacity-100"}`}
                />
                <button type="button" aria-label="Imagem anterior" disabled={current === 0} onClick={() => goTo(current - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-gray-900 shadow hover:bg-white disabled:opacity-0 transition">
                    <ChevronLeftIcon />
                </button>
                <button type="button" aria-label="Próxima imagem" disabled={current >= images.length - 1} onClick={() => goTo(current + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-gray-900 shadow hover:bg-white disabled:opacity-0 transition">
                    <ChevronRightIcon />
                </button>
                <span className="absolute bottom-2 right-2 rounded-full bg-black/60 px-2.5 py-0.5 text-xs font-semibold text-white tabular-nums">{current + 1}/{images.length}</span>
            </div>
            <div className="flex gap-2 overflow-x-auto pb-1">
                {
                    images.map((img, i) => (
                        <button key={i} type="button" onClick={() => goTo(i)} aria-label={`Ver imagem ${i + 1}`} className={`h-16 w-16 shrink-0 overflow-hidden rounded-lg ring-2 transition ${i === current ? "ring-secondary" : "ring-transparent opacity-70 hover:opacity-100"}`}>
                            <img src={img.cImgUrl || img.imgUrl} alt={`Miniatura ${i + 1}`} className="h-full w-full object-cover" />
                        </button>
                    ))
                }
            </div>
        </div>
    )
}
